import React from 'react';
import Navbar from '../Components/Navbar';
import Heroimg2 from '../Components/Heroimg2';
import Footer from '../Components/Footer';
import Detail from '../Components/Detail';


const Contact = () => {
  return (
    <div>
      <Navbar/>
      <Heroimg2 heading="CONTACT" />
      <Detail/>
      <Footer/>
    </div>
  )
}

export default Contact
